<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog
      as="div"
      :open="isOpen"
      class="relative z-[999]"
      @close="isOpen = false"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-50" />
      </TransitionChild>

      <div
        class="fixed inset-0 flex h-full w-full items-center justify-center p-4"
      >
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            class="flex h-auto max-h-full w-[998px] flex-col bg-white shadow-xl transition-all"
          >
            <div
              class="relative w-full bg-gray-default py-5 pl-4 pr-12 text-2xl font-medium text-primary md:px-18 md:pt-13 md:pb-11 md:text-3xl"
            >
              {{ generalStore.settings?.company_name }} Purchase<br />
              Protection Guarantee
              <UiIcon
                name="close"
                class="absolute right-5 top-5 h-8 w-8 cursor-pointer text-primary"
                @click="isOpen = false"
              />
            </div>

            <div class="space-y-5 overflow-auto p-4 md:space-y-9.5 md:p-16.5">
              <div class="flex">
                <div class="mr-6">
                  <UiIcon
                    name="check_circle"
                    class="h-8 w-8 text-info-text"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <h3 class="mb-6 text-2xl font-medium">Secure Checkout</h3>
                  <p
                    class="mb-4 text-sm font-normal md:text-base md:font-normal"
                  >
                    Secure Checkout At
                    {{ generalStore.settings?.company_name }}, we take the
                    security and protection of our customers' personal and
                    financial information very seriously. That's why we offer a
                    secure checkout process to ensure that all transactions are
                    safe and protected. Our secure checkout process uses the
                    latest encryption technologies to safeguard sensitive data
                    such as credit card details, billing and shipping addresses,
                    and personal information.
                  </p>
                  <p class="text-sm font-normal md:text-base md:font-normal">
                    This means that our customers can shop with confidence
                    knowing that their information is being protected at every
                    step of the checkout process. We strive to create a seamless
                    and secure shopping experience for our customers, from
                    browsing products to completing their purchase.
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="mr-6">
                  <UiIcon
                    name="check_circle"
                    class="h-8 w-8 text-info-text"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <h3 class="mb-6 text-2xl font-medium">
                    24/7 Customer Service
                  </h3>
                  <p class="text-sm font-normal md:text-base md:font-normal">
                    Our ravely-reviewed
                    <a class="underline">Customer Service team</a> of diamond
                    and jewelry experts is here for you 24/7 and offers
                    interactive diamond inspections.
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="mr-6">
                  <UiIcon
                    name="check_circle"
                    class="h-8 w-8 text-info-text"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <h3 class="mb-6 text-2xl font-medium">Lifetime Warranty</h3>
                  <p class="text-sm font-normal md:text-base md:font-normal">
                    We are committed to ensuring the quality of your purchase;
                    we will repair and maintain your jewelry for a lifetime.
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="mr-6">
                  <UiIcon
                    name="check_circle"
                    class="h-8 w-8 text-info-text"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <h3 class="mb-6 text-2xl font-medium">
                    Hassle-Free Returns with 100% Money Back Guarantee
                  </h3>
                  <p class="text-sm font-normal md:text-base md:font-normal">
                    If you are not 100% satisfied with your purchase, return it
                    in its original, unworn condition within 30 days, for a 100%
                    refund. No restocking fee. We will pay for the return
                    shipping (U.S. and Canada customers only).
                  </p>
                </div>
              </div>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";

const props = defineProps<{ modelValue: boolean }>();
const generalStore = useGeneralStore();

const emit = defineEmits(["update:modelValue"]);

const isOpen = computed<boolean>({
  set(val) {
    emit("update:modelValue", val);
  },
  get() {
    return props.modelValue;
  },
});
</script>
